import styled from '@emotion/styled'

export const MfaModalBody = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
